import { useVideo } from '../hooks/useVideo';
import type { VideoPlayer } from '../VideoTypes';

// https://regex101.com/r/CWmgOb/1
const YOUTUBE_REGEX =
	/(?:youtube(?:-nocookie)?\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

function YoutubePlayer({
	width,
	height,
	autoPlay,
	controlsType,
	loop,
	playsInline,
	muted,
	src,
	description,
	blockClass,
}: VideoPlayer) {
	const { componentId } = useVideo();
	const matchedSrc = src.match(YOUTUBE_REGEX);
	const videoId = matchedSrc?.[1];
	const params = `autoplay=${autoPlay}&loop=${loop ? `1&playlist=${videoId}` : '0'}&enablejsapi=1&iv_load_policy=3&modestbranding=1&rel=0&controls=${controlsType === 'none' ? 0 : 1}&playsinline=${playsInline ? '1' : '0'}&mute=${autoPlay || muted ? '1' : '0'}`;

	return (
		<div
			data-selection={componentId}
			className={`relative videoContainer vtex-store-video-1-x-videoContainer ${blockClass ? `videoContainer--${blockClass} vtex-store-video-1-x-videoContainer--${blockClass}` : ''}`}
		>
			<iframe
				data-testid="youtube-player"
				width={width}
				height={height}
				title={description}
				className={`videoElement vtex-store-video-1-x-videoElement ${blockClass ? `videoElement--${blockClass} vtex-store-video-1-x-videoElement--${blockClass}` : ''}`}
				src={`https://www.youtube.com/embed/${videoId}?${params}`}
				frameBorder="0"
				allowFullScreen
				allow="autoplay"
			/>
		</div>
	);
}

export default YoutubePlayer;
